const OpcaoPagamentoEnum = {
    PAGAR_NA_ENTREGA: 'Pagar na Entrega',
    PAGO_NO_SITE: 'Pago no Site'
}

export default OpcaoPagamentoEnum;
